import React from 'react';
import _Select from 'react-select/async';
import styled from 'styled-components/macro';
import { MultiValue } from './GroupsAndUsersInputBoxView';
import InputBase from '../form/InputBase';
import useTranslations from '../../hooks/useTranslations';

const Select = styled(_Select)`
  && {
    font-size: 14px;
  }
  ${({ $customCSS }) => $customCSS}
`;

const UsersInputBoxView = props => {
  const t = useTranslations();

  return (
    <>
      <Select
        cacheOptions
        components={{
          MultiValue,
          valueContainer: InputBase,
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null
        }}
        openMenuOnClick={false}
        placeholder={t('select.users.placeholder')}
        noOptionsMessage={e =>
          e.inputValue ? t('select.users.noResults') : null
        }
        {...props}
        value={props.users}
        onChange={props.setUsers}
        loadOptions={props.getUsersPromise}
        id="users-select"
        $customCSS={props.customCSS}
      />
    </>
  );
};

export default UsersInputBoxView;
